import React, { ReactNode, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from '@inertiajs/react';

import Valuation from '../../Data/Valuation';
import ThreeYearBreakdown from '../../Data/ThreeYearBreakdown';
import PlCategory from '../../Data/PlCategory';
import AuthedLayout from '../../Layouts/Authed';
import FormHeader from '../../Components/Forms/FormHeader';
import { PeriodLabels } from '../../Data/PeriodLabels';
import YearSummary from './NetRevenueSummary/YearSummary';

interface Props {
	valuation: Valuation;
	currentYear: number;
	periodLabels?: PeriodLabels;
	categories: PlCategory[];
	netRevenue: ThreeYearBreakdown;
	netRevenueWithProForma: number;
	totalISA: number;
	totalExpenses: ThreeYearBreakdown;
	totalExpensesWithProForma: number;
	previousPage: string;
	nextPage: string;
}

const TotalExpenseSummary = (props: Props) => {
	const one_year_ago = props.currentYear - 1;
	const two_years_ago = props.currentYear - 2;

	useEffect(() => {
		scrollTo(0,0);
	}, []);

	return (
		<div>
			<FormHeader
				agencyName={props.valuation.agency_name}
				effectiveDate={props.valuation.effective_date}
				pageName='Net Revenue Summary'
			/>
			{/* table for each year */}
			{/* tables for year-1 and year-2 are small - two cols? */}
			<Row>
				<Col lg={6}>
					<h2 className='h3'>{props.periodLabels?.two_years_ago.label ?? two_years_ago} <small className="text-muted h5">({props.periodLabels?.two_years_ago.range ?? two_years_ago})</small></h2>
					<YearSummary
						name={'value_two_years_ago'}
						categories={props.categories}
						netRevenue={props.netRevenue.value_two_years_ago}
						totalExpenses={props.totalExpenses.value_two_years_ago}
						showNetRevenues={false}
					/>
				</Col>
				<Col lg={6}>
					<h2 className='h3'>{props.periodLabels?.one_year_ago.label ?? one_year_ago} <small className="text-muted h5">({props.periodLabels?.one_year_ago.range ?? one_year_ago})</small></h2>
					<YearSummary
						name={'value_one_year_ago'}
						categories={props.categories}
						netRevenue={props.netRevenue.value_one_year_ago}
						totalExpenses={props.totalExpenses.value_one_year_ago}
						showNetRevenues={false}
					/>
				</Col>
			</Row>

			<h2 className='h3'>{props.periodLabels?.current.label ?? props.currentYear} <small className="text-muted h5">({props.periodLabels?.current.range ?? props.currentYear})</small></h2>
			<Row>
				<Col>
					<YearSummary
						name={'value_current'}
						categories={props.categories}
						netRevenue={props.netRevenue.value_current}
						netRevenueWithProForma={props.netRevenueWithProForma}
						totalExpenses={props.totalExpenses.value_current}
						totalISA={props.totalISA}
						totalExpensesWithProForma={props.totalExpensesWithProForma}
						showProFormaColumns={true}
						showNetRevenues={false}
					/>
				</Col>
			</Row>

			<div className='d-flex justify-content-between'>
				<Link href={props.previousPage} className='mt-4 btn btn-outline-primary'>
					Back
				</Link>
				<Link href={props.nextPage} className='mt-4 btn btn-primary'>
					Next
				</Link>
			</div>
		</div>
	);
};

TotalExpenseSummary.layout = (page: ReactNode) => (
	<AuthedLayout>{page}</AuthedLayout>
);

export default TotalExpenseSummary;
